import React, { useState, useEffect } from "react";

const TypingText = ({ text, speed = 150 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const typing = setInterval(() => {
      setDisplayedText((prev) => prev + text[index]);
      setIndex((prev) => prev + 1);
    }, speed);

    if (index === text.length) {
      clearInterval(typing);
      setTimeout(() => {
        setDisplayedText("");
        setIndex(0);
      }, 1500); // Wait 1.5s before restarting
    }

    return () => clearInterval(typing);
  }, [index, text, speed]);

  return (
    <span className="font-bold font-sans text-xl sm:text-xl lg:text-xl text-bg-1/90">
      {displayedText}
      <span className="border-r-2 border-bg-1 animate-pulse ml-1"></span>
    </span>
  );
};

export default TypingText;
